export const DEFAULT_TIMEZONE = "America/Los_Angeles";

export const DEFAULT_CLOCK_IN_BONUS_POINTS = 5;

export const ATTENDANCE_SCORE_THRESHOLD_FOR_LATENESS_WARNING = 70;

export const LATENESS_DEDUCTED_POINTS_THRESHOLD_FOR_WARNING = 30;
